var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21C13 21.5523 13.5037 22 14.125 22H20.875C21.4963 22 22 21.5523 22 21C22 18.7909 19.9853 17 17.5 17C15.0147 17 13 18.7909 13 21Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.5C19.5 14.6046 18.6046 15.5 17.5 15.5C16.3954 15.5 15.5 14.6046 15.5 13.5C15.5 12.3954 16.3954 11.5 17.5 11.5C18.6046 11.5 19.5 12.3954 19.5 13.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2H12.4726C13.1933 2 13.6774 2.73936 13.3891 3.39994L11.7745 7.10006C11.6632 7.35507 11.6632 7.64493 11.7745 7.89994L13.3891 11.6001C13.6774 12.2606 13.1933 13 12.4726 13H2.75V22C2.75 22.4142 2.41421 22.75 2 22.75C1.58579 22.75 1.25 22.4142 1.25 22V2C1.25 1.58579 1.58579 1.25 2 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.daca09b6f401511e0767b240a8c6b35b.svg";
export { ForwardRef as ReactComponent };